if (!customElements.get('logos-slider')) {
  class LogosSlider extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initSlider();
    }

    initSlider() {
      if (!this.querySelector('[data-slider]')) return;

      this.options = {
        slidesPerView: 4,
        spaceBetween: 0,
        disable: true,
        centerInsufficientSlides: true,
        slideVisibleClass: 'swiper-slide-visible',
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
        breakpoints: {
          750: {
            slidesPerView: 5,
            disable: false,
          },
          1299: {
            slidesPerView: 6,
          },
        },
      };

      if (this.hasAttribute('data-autoplay')) {
        this.options.autoplay = {
          delay: this.dataset.autoplaySpeed,
        };
      }

      this.slider = new Swiper(
        this.querySelector('[data-slider]'),
        this.options,
      );
    }
  }
  customElements.define('logos-slider', LogosSlider);
}
